<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-40" v-if="tour">
      <tour-edit :tour="tour"></tour-edit>
    </div>
    <div class="md-layout-item md-size-60" v-if="tour">
      <tour-tabs :tour="tour"></tour-tabs>
    </div>
  </div>
</template>

<script>
import tourApi from "@/services/api/tour";

import TourEdit from "./TourEdit";
import TourTabs from "./TourTabs";

export default {
  props: ["tour_id"],

  data() {
    return {
      tour: null
    };
  },

  components: {
    TourEdit,
    TourTabs
  },

  methods: {
    getTour(id) {
      tourApi.getTour(id).then(response => {
        this.tour = response.data;
      });
    }
  },

  watch: {
    "$route.params.tour_id": function(id) {
      this.getTour(id);
    }
  },

  mounted() {
    this.getTour(this.tour_id);
  }
};
</script>
